import { render, staticRenderFns } from "./ReferralStatus.vue?vue&type=template&id=10f170ed&scoped=true"
import script from "./ReferralStatus.vue?vue&type=script&lang=js"
export * from "./ReferralStatus.vue?vue&type=script&lang=js"
import style0 from "./ReferralStatus.vue?vue&type=style&index=0&id=10f170ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f170ed",
  null
  
)

export default component.exports